import { formatNumberAsPercent, formatNumberAsPrice } from '@shared/common'
import { Types } from 'service-api'
import { MembershipBenefitType } from './types'

export const getBenefitDiscount = (benefit: Types.BenefitAdminDto | Types.BenefitClientDto) => {
  if (benefit.priceType === 'RATE') {
    return `${benefit.amount ? formatNumberAsPercent(benefit.amount * 100, { keepZero: false }) : ''}`
  } else {
    return `${benefit.amount ? formatNumberAsPrice(benefit.amount, undefined, undefined, false) : ''}`
  }
}

export const isConsumable = (type?: MembershipBenefitType) => type === 'CONSUMABLE'

export const sortBenefits = (benefits: Types.BenefitAdminDto[] | Types.BenefitClientDto[]) => {
  return [...benefits].sort((a, b) => {
    if (isConsumable(a.type) && !isConsumable(b.type)) {
      return -1
    }
    if (!isConsumable(a.type) && isConsumable(b.type)) {
      return 1
    }
    if (!isConsumable(a.type) && !isConsumable(b.type) && a.amount && b.amount) {
      return a.amount - b.amount
    }
    if (a.qty && b.qty) {
      return a.qty - b.qty
    }
    return 0
  })
}

export const getBenefitOffer = (benefit: Types.BenefitAdminDto | Types.BenefitClientDto, offerId: string) => {
  return benefit.benefitOffers?.find(
    (benefitOffer) => benefitOffer.offer?.id === offerId || benefitOffer?.offerId === offerId
  )
}

export const getBenefitOfferLabel = (benefit: Types.BenefitAdminDto, offerId: string) =>
  `${getBenefitOffer(benefit as Types.BenefitAdminDto, offerId || '')?.offer?.displayName || ''} - ${getBenefitDiscount(
    benefit as Types.BenefitAdminDto
  )}`

export const getUniqueBenefitOffers = (
  benefitConsumptionRecords?: Types.APIBenefitConsumptionRecordAdminDtoResponse
) => {
  const benefitOffers = new Set(benefitConsumptionRecords?.results.map((r) => r.benefit?.id))
  return Array.from(benefitOffers).map((id) => {
    const benefitConsumptionRecord = benefitConsumptionRecords?.results.find((r) => r.benefit?.id === id)
    return {
      label: getBenefitOfferLabel(benefitConsumptionRecord!.benefit!, benefitConsumptionRecord!.offerId || ''),
      value: getBenefitOfferLabel(benefitConsumptionRecord!.benefit!, benefitConsumptionRecord!.offerId || ''),
    }
  })
}

export const isUnlimitedBenefitsOnly = (benefits: Types.BenefitAdminDto[] | Types.BenefitClientDto[]) => {
  return benefits.every((benefit) => !isConsumable(benefit.type))
}
